// @core/api/endpoints/analytics/delete_report_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/analytics';

/**
 * Delete report schedule
 * Deletes an automated report schedule.
 */
export async function DeleteReportSchedule(
  schedule_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/report-schedules/:schedule_id`;
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
